import { Component, EventEmitter, forwardRef, Input, OnInit, Output, TemplateRef } from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormGroupDirective,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'roblex-change-input',
    templateUrl: './change-input.component.html',
    styleUrls: ['./change-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ChangeInputComponent),
        },
    ],
})
export class ChangeInputComponent implements OnInit, ControlValueAccessor {
    /**
     * Input form control name of input form field component
     */
    @Input() formControlName: string;
    @Input() appearance: 'standard' | 'fill' | 'outline' = 'outline';
    @Input() className: string;
    @Input() iconLeft: string;
    @Input() iconRight: string;
    @Input() iconRightDisabled: boolean | null;
    /**
     * Input label of input field component
     */
    @Input() label = 'input form field label';
    /**
     * Input disabled of input field component
     */
    @Input() disabled: boolean = false;
    /**
     * Input currency name of calculator input component
     */
    @Input() currencyName: string;
    /**
     * Input text right of input form field component
     */
    @Input() templateRight: TemplateRef<any>;
    /**
     * Output keyup of calculator input component
     */
    @Output() valueChange: EventEmitter<any> = new EventEmitter();
    @Output() backSpace: EventEmitter<any> = new EventEmitter();
    @Output() suffix: EventEmitter<any> = new EventEmitter();
    /**
     * Control  of input form field component
     */
    control: AbstractControl;
    /**
     * Timeout  of calculator input component
     */
    timeout: any;
    /**
     * Interval  of calculator input component
     */
    interval = 500;
    /**
     * Value  of input field component
     */
    _value = '';
    /**
     * Gets value
     */
    get value() {
        return this._value;
    }
    /**
     * Sets value
     */
    set value(val) {
        this._value = val;
        this.onChangeCallback(this._value);
    }
    /**
     * Gets form
     */
    get form() {
        return this.controlContainer?.formDirective
            ? (this.controlContainer?.formDirective as FormGroupDirective)?.form
            : null;
    }
    get classFormFiel() {
        const classList = {};

        classList['mat-form-field-invalid'] = this.control?.touched && this.control?.invalid

        if (this.className) {
            classList[this.className] = true;
        }

        return classList;
    }
    /**
     * Determines whether touched callback on
     */
    onTouchedCallback: () => void;
    /**
     * Propagate change of input field component
     */
    onChangeCallback = (_: any) => {};
    /**
     * Creates an instance of calculator input component.
     * @param controlContainer ControlContainer
     */
    constructor(public controlContainer: ControlContainer) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.control = this.form.get(this.formControlName);
    }
    /**
     * Determines whether keyup send on
     * @param event any
     */
    onKeyupEvent(event: any): void {
        const value = event.target.value as string;
        const newValue =+ this.reestructureValue(value);
        if(newValue){
            this.writeValue(newValue===0? null:newValue);
        }else{
            this.writeValue(null);
        }
        this.valueChange.emit(newValue);
    }
    reestructureValue(value:string):string{
        if(value){
            const valueDepure = value.replace(new RegExp('[,.]', 'g'), '');
            if(valueDepure.length>1){
                const newValue = (valueDepure[0]+'.'+valueDepure.substring(1));
                return newValue;
            }else{
                return valueDepure;
            }
        }else{
            return '';
        }
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any): void {
        this.value = value;
        this.onChangeCallback(this.value);
    }
    onClickMatSuffix() {
        this.suffix.emit();
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
